import { DatePipe } from '@angular/common';
import {
    Component,
    OnInit,
    Input,
    ViewChild,
    EventEmitter,
    Output,
    ElementRef,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { IAvailableTypes } from 'src/app/core/models/available-types.interface';
import { ICategory } from 'src/app/core/models/category.interface';
import { PageParams } from 'src/app/core/models/page-params.model';
import { UploadFileService } from 'src/app/core/services/upload-file.service';
import { UserService } from 'src/app/core/services/user.service';
import { FileStatus } from 'src/app/shared/enums/file-status.enum';
import * as XLSX from 'xlsx';
import { SaleOrderInvoiceType } from '../../../../shared/enums/sale-order-invoice-type.enum';
import { ISaleOrder } from '../../models/sale-order.interface';
import { ConstantService } from 'src/app/core/services/constant.service';
import { ConfirmPopupDialog } from 'src/app/shared/popups/confirm-popup/confirm-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { PlaceStatus } from 'src/app/shared/enums/place-status.enum';
import { ICountry } from 'src/app/core/models/country.interface';
import { SaleOrderErrorType } from 'src/app/shared/enums/sale-order-error-type.enum';
import { ConsolidateShipmentService } from 'src/app/core/services/consolidate-shipments.service';
import { AddToExistingBatchComponent } from '../../../../shared/components/add-to-existing-batch/add-to-existing-batch.component';
import { CreateBatchPopupComponent } from '../../../../shared/components/create-batch-popup/create-batch-popup.component';
import { SaleOrderService } from '../../services/sale-order.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import {
    ParcelStatus
} from "../../../consolidate-shipments/components/consolidate-shipments-details/consolidate-shipment-packages/consolidate-shipment-packages.component";
import { IParcelItem } from '../../models/parcel-item';
import { DeliveryStatusLabelPipe } from 'src/app/shared/pipes/delivery-status-label.pipe';
import {
    formatDisplayOrderTotal,
    formatNetAmountExcVat,
    formatNetEciTotalEuro,
    formatNetEciVatEuro,
    formatNetVat,
} from '../../utils/sale-order-list-net-amounts.util';

const Field_List_Value: any = {
    reorder: false,
    eciOrderDate: false,
    orderId: false,
    stripeAmount: false,
    stripeRefundAmount: false,
    marketplaceVat: false,
};
@Component({
    selector: 'eci-table-sales-order',
    templateUrl: './table-sales-order.component.html',
    styleUrls: ['./table-sales-order.component.scss'],
})
export class TableSalesOrderComponent implements OnInit, OnChanges {
    constructor(
        private router: Router,
        public userSvc: UserService,
        public uploadFileSvc: UploadFileService,
        private datePipe: DatePipe,
        private constSvc: ConstantService,
        public dialog: MatDialog,
        public route: ActivatedRoute,
        private saleOrderSvc: SaleOrderService,
        private consolidateShipmentService: ConsolidateShipmentService,
        private localStorageSvc: LocalStorageService,
        private notify: NotificationService,
        private deliveryStatusLabelPipe: DeliveryStatusLabelPipe,
    ) { }

    @Input() isBgBlue: boolean = true;
    @Input() dataSource;
    @Input() displayedColumns;
    @Input() availableCategories: ICategory[];
    @Input() availableTypes: IAvailableTypes;
    @Input() SaleOrderStatus: any;
    @Input() sumOfTotalFIelds: any[];
    @Input() sumOfTotalFIeldsIncludingCancelled: any[];
    @Input() showDownloadBtn: boolean = true;
    @Input() showConfirmBtn: boolean = false;
    @Input() showExportBtn: boolean = true;
    @Input() showBatchBtn: boolean = true;
    @Input() showAddExistingBatchBtn: boolean = true;
    @Input() pageParams: PageParams = new PageParams();
    @Input() listOfSelectedItems: number[] = [];
    @Input() isCreateMode: boolean;
    @Input() listOfSelectedItemsBody: ISaleOrder[] = []; // TO DO NEED TO COMBINE WITH SELECTED ITTEMS
    @Input() showConsolidateBtn: boolean = false;
    @Input() countries: ICountry[] = [];
    @Output() listOfSelectedItemsChange: EventEmitter<number[]> =
        new EventEmitter<number[]>(null);
    @Output() listOfSelectedItemsBodyChange: EventEmitter<ISaleOrder[]> =
        new EventEmitter<ISaleOrder[]>(null); // TO DO NEED TO COMBINE WITH SELECTED ITTEMS
    @Output() pageChange: EventEmitter<PageParams> =
        new EventEmitter<PageParams>(null);
    @Output() editProducts: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() downInvoice: EventEmitter<number> = new EventEmitter<number>(
        null
    );
    @Output() sortRows: EventEmitter<Sort> = new EventEmitter<Sort>(null);
    // @Output() showEditPopup: EventEmitter<boolean> = new EventEmitter<boolean>(false);
    @Output() documentSave: EventEmitter<number> = new EventEmitter<number>(
        null
    );
    @Output() documentUpload: EventEmitter<{ id: number; e: any; file: any }> =
        new EventEmitter<{ id: number; e: any; file: any }>(null);
    @Output() documentDelete: EventEmitter<number> = new EventEmitter<number>(
        null
    );
    @Output() exportSalesToExcel: EventEmitter<any> = new EventEmitter<any>(
        null
    );
    @Output() recalculateTaxReport: EventEmitter<any> = new EventEmitter<any>(
        null
    );
    @Output() syncWithAfterShip: EventEmitter<any> = new EventEmitter<any>(
        null
    );
    @Output() consolidateShipments: EventEmitter<any> = new EventEmitter<any>(
        null
    );
    @Output() showEditInvoicePopup: EventEmitter<{ id: number; type: string }> =
        new EventEmitter<{ id: number; type: string }>(null);
    @Output() documentSaveElement: EventEmitter<number> =
        new EventEmitter<number>(null);
    @Output() documentUploadElement: EventEmitter<any> = new EventEmitter<any>(
        null
    );
    @Output() changeSOStatus: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() createSpecificInvoice: EventEmitter<any> = new EventEmitter<any>(
        null
    );
    @Output() addNewSO: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() listUpdated: EventEmitter<any> = new EventEmitter<any>();
    @Output() loadNextPage: EventEmitter<any> = new EventEmitter<any>();
    @Output() existingOrdersLoaded: EventEmitter<number[]> = new EventEmitter<number[]>();

    hiddenFieldList = Field_List_Value;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('table', { static: true, read: ElementRef }) table: ElementRef;
    @ViewChild('scrollContainer') scrollContainer!: ElementRef;

    PlaceStatus = PlaceStatus;

    is4ConsolShipment: boolean = false;
    consolShipmentId: any;
    addSO: boolean = false;
    existingConsolOrderIds: number[] = [];
    private wasAtBottom: boolean = false;

    get documentFileTypes(): string[] {
        return [
            ...this.uploadFileSvc.textFileFormats,
            ...this.uploadFileSvc.fileFormats,
        ];
    }

    OrderStatusCancelled: number;

    pageChanged(e): void {
        this.pageChange.emit(e);
        this.table.nativeElement.scrollIntoView();
    }

    ngOnInit(): void {
        this.setReturnsColumns();

        this.route.queryParams.subscribe((vals) => {
            if (vals.consolShipment && Number(vals.consolShipment) === 1) {
                this.is4ConsolShipment = true;
            }
            if (vals['id'] && vals['addSO']) {
                this.consolShipmentId = vals['id'];
                this.addSO = vals['addSO'];
            }
        });

        this.callHiddenFields();
        this.userSvc.hiddenFieldEvent.subscribe((res)=>{
            if(res !== null)
            {
                this.callHiddenFields();
            }
        });
        if (this.consolShipmentId && this.addSO) {
            this.getConsolShipmentDetails(this.consolShipmentId);
        }

        this.saleOrderSvc.unselectCheckbox.subscribe((result) => {
            if (result != null) {
                this.listOfSelectedItems = [];
                this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
                this.listOfSelectedItemsBodyChange.emit([]);
            }
        });
    }

    ngAfterViewInit() {
        this.scrollContainer.nativeElement.addEventListener('scroll', () => {
            const element = this.scrollContainer.nativeElement;
            const atBottom =
                element.scrollTop + element.clientHeight >= element.scrollHeight - 10;

            // Emit loadNextPage only on transitions from "not at bottom" to "at bottom"
            if (atBottom && !this.wasAtBottom) {
                this.wasAtBottom = true;
                this.loadNextPage.emit();
            } else if (!atBottom && this.wasAtBottom) {
                this.wasAtBottom = false;
            }
        });
    }

    callHiddenFields()
    {
        if (this.isAdmin) {
            let fieldListShow = this.localStorageSvc.get('SALES_ORDER_VISIBLITY_FIELD_RULE') || '';
            if (!fieldListShow) {
                this.constSvc
                    .getSettingsDetails('SALES_ORDER_VISIBLITY_FIELD_RULE')
                    .subscribe((data) => {
                        if (data.value) {
                            let fields = JSON.parse(data.value);
                            fields.map((field) => {
                                this.hiddenFieldList[field.key] = field.value;
                            });
                        }
                    });
            } else {
                fieldListShow.map((field) => {
                    this.hiddenFieldList[field.key] = field.value;
                });
            }
        }
    }
    navigateTo(id): void {
        this.router.navigate([]).then((result) => {
            window.open(
                `/sales-order-management/order-details/${id}`,
                '_blank'
            );
        });
    }

    navigateToConsolDetails(consolNumber): void {
        this.router.navigate([]).then((result) => {
            window.open(
                `/consolidate-shipments/consol-shipment-details/${consolNumber}`,
                '_blank'
            );
        });
    }

    editProductItem(element: any): void {
        this.editProducts.emit(element);
    }

    showEditPopup(id, type) {
        this.showEditInvoicePopup.emit({ id: id, type: type });
    }

    findCategoryName(id): string {
        if (!this.availableCategories) return;
        const category = this.availableCategories.find((el) => el.id == id);
        return category ? category.name : '';
    }

    downloadInvoice(id): void {
        this.downInvoice.emit(id);
    }

    sortData(e: Sort): void {
        this.sortRows.emit(e);
    }

    get hideCol(): boolean {
        return this.userSvc.isDelicated;
    }

    exportToExcel(sheetName: string = 'SheetJS') {
        let ws: XLSX.WorkSheet;
        ws = XLSX.utils.table_to_sheet(this.table.nativeElement, {
            cellStyles: true,
        });

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, sheetName + '.xlsx', {
            cellStyles: true,
            bookSST: true,
        });
    }

    get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    get fieldList(): any {
        return this.hiddenFieldList;
    }

    get isDelegateAdmin(): boolean {
        return this.userSvc.isDelegatedAdmin;
    }

    get isAllSelected(): boolean {
        const selectableItems = this.dataSource?.filter(
            (o) => !this.isExistingConsolOrder(o.id)
        );
        return (
            selectableItems?.length > 0 &&
            this.listOfSelectedItems?.length > 0 &&
            selectableItems.every((o) =>
                this.listOfSelectedItems.includes(o.id)
            )
        );
    }

    clearSelection() {
        this.listOfSelectedItems =[];
        this.listOfSelectedItemsBody = [];
        this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
        this.listOfSelectedItemsBodyChange.emit(this.listOfSelectedItemsBody);
    }

    isChecked(id: number): boolean {
        return !!this.listOfSelectedItems.find((el) => el === id);
    }

    isCancelNote(id: number): boolean {
        return (
            this.dataSource.find((el) => el.id === id)?.type ===
            SaleOrderInvoiceType.CANCEL_NOTE
        );
    }

    selectAllChanged(event: MatCheckboxChange): void {
        if (event.checked) {
            const selectableOrders = this.dataSource.filter(
                (el) => !this.isExistingConsolOrder(el.id)
            );
            const items = [
                ...this.listOfSelectedItems,
                ...selectableOrders.map((el) => el.id),
            ];
            this.listOfSelectedItems = items.filter((obj, index) => {
                return index === items.findIndex((o) => obj == o);
            });
            this.listOfSelectedItemsBodyChange.emit(selectableOrders);
        } else {
            const items = this.listOfSelectedItems;
            this.listOfSelectedItems = items.filter((obj) => {
                return this.dataSource.findIndex((o) => obj == o.id) == -1;
            });
            this.listOfSelectedItemsBodyChange.emit([]);
        }
        this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
    }

    selectionChanged(event: MatCheckboxChange, item): void {
        if (event.checked && this.isExistingConsolOrder(item.id)) {
            this.notify.showError('This order is already added to the shipment');
            event.source.checked = false;
            return;
        }
        if (event.checked) {
            if (!this.isChecked(item.id)) {
                this.listOfSelectedItems.push(item.id);
                this.listOfSelectedItemsBody.push(item);
            }
        } else {
            if (this.isChecked(item.id)) {
                this.listOfSelectedItems.splice(
                    this.listOfSelectedItems.findIndex((el) => el === item.id),
                    1
                );
                this.listOfSelectedItemsBody.splice(
                    this.listOfSelectedItems.findIndex((el) => el === item.id),
                    1
                );
            } else {
                this.listOfSelectedItems = this.listOfSelectedItems.filter(id => id !== item.id);
            }
        }
        this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
        this.listOfSelectedItemsBodyChange.emit(this.listOfSelectedItemsBody);
    }

    getTotalVat(element): string {
        return formatNetVat(element);
    }

    getNetOrderTotal(element): string {
        return formatDisplayOrderTotal(element);
    }

    getNetAmountExcVat(element): string {
        return formatNetAmountExcVat(element);
    }

    getNetEciVatEuro(element): string {
        return formatNetEciVatEuro(element);
    }

    getNetEciTotalEuro(element): string {
        return formatNetEciTotalEuro(element);
    }

    devideValue(value1, value2): string {
        return (parseFloat(value1 || 0) / parseFloat(value2 || 0) || 0).toFixed(
            2
        );
    }

    getMarketPlaceVAT(element): any {
        const marketplaceName =
            element?.marketplace?.saleOrderMarketplace?.marketplaceInfo?.name ||
            '';
        const vatCharges = Number(element?.marketplace?.vatCharges || 0);
        return vatCharges == 0.1 && marketplaceName === 'wix'
            ? 'Not Available'
            : vatCharges?.toFixed(2);
    }

    getRate(prod: any): string {
        if (!prod?.vatRate) return null;

        return (prod?.vatRate / prod?.price).toFixed(2);
    }

    dateConvert(date: any): string {
        if (!date || date === 'undefined' || date === 'null') {
            return null;
        }
        // return this.datePipe.transform(new Date(date).toISOString().slice(0, 16), 'dd/MM/yyyy');
        return this.datePipe.transform(new Date(date), 'dd/MM/yyyy');
    }

    checkAndConvertDateOrder(date: any): string {
        if (!date) {
            return null;
        }
        if (
            date === 'undefined' ||
            date === 'null' ||
            date.toString().includes('0000-00-00')
        ) {
            return 'Invalid Date';
        } //example for additional fix related incorrect storing date on DB after Parsing XL """ || date === 'undefined' || date === 'null' || date === '0000-00-00 00:00:00' """
        return this.dateConvert(date);
    }

    navigateToErrors(marketplaceOrderId): void {
        if (!marketplaceOrderId) return;

        this.router.navigateByUrl(
            `/sale-order-errors?orderId=${marketplaceOrderId}`
        );
    }

    uploadShow(status: number): boolean {
        return status == FileStatus.PENDING;
    }

    downloadShow(status: number): boolean {
        return status == FileStatus.UPLOADED;
    }

    uploadFile(e, file, id): void {
        this.documentUpload.emit({ id: id, e: e, file: file });
    }

    downloadFile(id): void {
        this.documentSave.emit(id);
    }

    deleteDoc(id): void {
        if (!id) return;
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm deleting';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe((value) => {
            if (!value) return;

            this.documentDelete.emit(id);
        });
    }

    getTableRowColor(row: any): string {
        switch (true) {
            case row?.hasReorder && (this.isAdmin || this.isDelegateAdmin):
                return 'bisquit';
            case row?.isDuplicateOrder:
                return 'gray';
            case row?.hasDuplicate:
                return 'duplicate';
            default:
                return '';
        }
    }

    public sum(key: string, key2: string = '') {
        let toalValue = 0;
        if (this.dataSource != undefined) {
            toalValue = this.dataSource.reduce(function (total, row) {
                if (key2 != '') {
                    return (
                        total +
                        ((row[key] > 0 ? parseFloat(row[key]) : 0) ||
                            (row[key2] > 0 ? parseFloat(row[key2]) : 0))
                    );
                } else if (key == 'getMarketPlaceVAT') {
                    let marketplaceName =
                        row?.marketplace?.saleOrderMarketplace?.marketplaceInfo
                            ?.name || '';
                    let vatCharges = Number(row?.marketplace?.vatCharges || 0);
                    vatCharges == 0.1 && marketplaceName === 'wix'
                        ? 'Not Available'
                        : vatCharges;
                    return total + vatCharges;
                } else if (key == 'getTotalVat') {
                    return (
                        total +
                        (parseFloat(row?.eciVat || 0) +
                            parseFloat(row?.shipmentVat || 0) || 0)
                    );
                } else {
                    return total + (row[key] > 0 ? parseFloat(row[key]) : 0);
                }
            }, 0);
            return toalValue;
        } else {
            return 0;
        }
    }

    getErrorTooltip(errorsList: string): string {
        const errors = errorsList
            ?.split(',')
            ?.map((el) => SaleOrderErrorType[Number(el)]);

        return errors.join(', ');
    }

    hasLabelFailure(element: ISaleOrder): boolean {
        return (element?.parcel || []).some((p) => p.labelStatus === ParcelStatus.Failure);
    }

    getLabelFailureTooltip(element: ISaleOrder): string {
        return (element?.parcel || [])
            .filter((p) => p.labelStatus === ParcelStatus.Failure)
            .map((p) => p.failureReason || 'Label creation failed')
            .join('\n');
    }

    public cancelConsolshipment(): void {
        this.router.navigateByUrl(`/consolidate-shipments`);
    }

    navigateToShipment(id): void {
        if (!id) {
            return;
        }
        window.open(`customers-order/order-details/${id}`, '_blank');
    }

    getConsolShipmentDetails(id: any) {
        this.consolidateShipmentService.getShipmentById(id).subscribe((res) => {
            if (res) {
                this.existingConsolOrderIds = (res?.saleOrders || []).map(
                    (saleOrder) => saleOrder?.id
                );
                this.existingOrdersLoaded.emit(this.existingConsolOrderIds);
            }
        });
    }

    isExistingConsolOrder(id: number): boolean {
        return this.existingConsolOrderIds.includes(id);
    }

    consolidateSaleOrders() {
        if (this.consolShipmentId && this.addSO) {
            this.addNewSO.emit(this.consolShipmentId);
        } else {
            this.consolidateShipments.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes['availableTypes'] &&
            changes['availableTypes'].currentValue != null
        ) {
            this.availableTypes = changes['availableTypes'].currentValue;
            this.setReturnsColumns();
        }

        if (changes['dataSource'] && this.scrollContainer) {
            const prev = changes['dataSource'].previousValue || [];
            const curr = changes['dataSource'].currentValue || [];

            const prevLen = Array.isArray(prev) ? prev.length : 0;
            const currLen = Array.isArray(curr) ? curr.length : 0;

            // When more rows are appended (cursor load) *and* we were previously at bottom,
            // nudge the scroll slightly up so the user sees they're not at the absolute end,
            // but still close enough that another small scroll down will trigger the next load.
            if (prevLen > 0 && currLen > prevLen && this.wasAtBottom) {
                setTimeout(() => {
                    const element = this.scrollContainer.nativeElement;
                    if (element && element.scrollHeight > element.clientHeight) {
                        const NUDGE_PX = 80;
                        element.scrollTop = Math.max(0, element.scrollTop - NUDGE_PX);
                        this.wasAtBottom = false;
                    }
                });
            }
        }
    }

    setReturnsColumns() {
        this.OrderStatusCancelled = this.availableTypes
            ? this.availableTypes.SaleOrderStatus.find(
                (el) => el.name === 'CANCELED'
            ).id
            : null;
    }

    //edit batch popup component
    navigateEditBatch(): void {
        const dialogRef =  this.dialog.open(AddToExistingBatchComponent, {
            autoFocus: false
        });
        dialogRef.componentInstance.theSelectedSaleOrders = this.listOfSelectedItemsBody;
        dialogRef.afterClosed().subscribe((value) => {
            this.clearSelection();
            if (!value) return;
            if(value == true){
                this.notify.showSuccessMessage(
                    'Confirmed. SO added to batch'
                );
                this.listUpdated.emit();
            }
        });
    }

    navigateBatchCreate(): void {
        const dialogRef = this.dialog.open(CreateBatchPopupComponent, {
            autoFocus: false
        });
        dialogRef.componentInstance.theSelectedSaleOrders = this.listOfSelectedItemsBody;
        dialogRef.componentInstance.createBatch = true;
        dialogRef.afterClosed().subscribe((value) => {
            this.clearSelection();
            if (!value) return;
            if(value == true){
                this.notify.showSuccessMessage(
                    'Confirmed. SO added to batch'
                );
                this.listUpdated.emit();
            }
        });
    }

    getBatchType(origin, destination) {
        if (origin != '' && destination != '') {
            const selectedOriginCountry = this.countries?.find(
                (c) => c.code === origin
            );
            const selectedDestinationCountry = this.countries?.find(
                (c) => c.code === destination
            );
            let selectedBatchThreshold = '';
            if (!!selectedOriginCountry && !!selectedDestinationCountry) {
                if (
                    selectedOriginCountry.isEurope &&
                    selectedOriginCountry.code !== 'GB' &&
                    selectedDestinationCountry.code === 'GB'
                ) {
                    selectedBatchThreshold = 'EU_TO_UK';
                } else if (
                    !selectedOriginCountry.isEurope &&
                    selectedOriginCountry.code !== 'GB' &&
                    selectedDestinationCountry.code === 'GB'
                ) {
                    selectedBatchThreshold = 'NON_EU_TO_UK';
                } else if (
                    selectedOriginCountry.isEurope &&
                    selectedOriginCountry.code !== 'GB' &&
                    selectedDestinationCountry.isEurope &&
                    selectedDestinationCountry.code !== 'GB'
                ) {
                    selectedBatchThreshold = 'EU_TO_EU';
                } else if (
                    (!selectedOriginCountry.isEurope ||
                        selectedOriginCountry.code === 'GB') &&
                    selectedDestinationCountry.isEurope &&
                    selectedDestinationCountry.code !== 'GB'
                ) {
                    selectedBatchThreshold = 'NON_EU_TO_EU';
                } else if (
                    selectedOriginCountry.isEurope &&
                    selectedOriginCountry.code !== 'GB' &&
                    (selectedDestinationCountry.isEurope ||
                        selectedDestinationCountry.code === 'GB')
                ) {
                    selectedBatchThreshold = 'EU_TO_NON_EU';
                }
                return selectedBatchThreshold;
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    getConsolArray(consols) {
        return consols !== null ? consols?.split(',') : [];
    }

    formatHistoryStatusLabel(statusId: number | null | undefined): string {
        if (statusId == null) {
            return '—';
        }
        return this.deliveryStatusLabelPipe.transform(statusId) || '—';
    }

    // TODO: move this to one service
    public canHandleLabel(
        order: ISaleOrder,
        type: 'show' | 'create' | 'refresh'
    ): boolean {
        if (!order.parcel?.length) return false;

        switch (type) {
            case 'show':
                return order.parcel.some(p => p.labelStatus === ParcelStatus.Created);
            case 'create':
                return order.parcel.some(
                    (p) =>
                        p.labelStatus === ParcelStatus.Failure ||
                        (!p.labelStatus &&
                            p.labelStatus !== ParcelStatus.Created &&
                            p.labelStatus !== ParcelStatus.Creating),
                );
            case 'refresh':
                return order.parcel.some(p => p.labelStatus === ParcelStatus.Creating);
        }
    }

    public viewParcelLabel(order: ISaleOrder): void {
        this.saleOrderSvc.downloadParcelLabel([order.id]);
    }

    public canUploadLabel(order: ISaleOrder): boolean {
        return this.isAdmin && !!order.parcel?.length;
    }

    public uploadParcelLabel(order: ISaleOrder, event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file || !order.parcel?.length) {
            return;
        }

        const parcelId = order.parcel[0].id;
        this.saleOrderSvc.uploadParcelLabel(parcelId, file).subscribe({
            next: (res) => {
                this.updateParcel(order.id, parcelId, { labelStatus: res.data?.labelStatus || 'created' });
                this.notify.showSuccessMessage('Label uploaded successfully');
                input.value = '';
            },
            error: () => {
                this.notify.showError('Label upload failed');
                input.value = '';
            },
        });
    }

    public createLabel(order: ISaleOrder): void {
        console.log(order);
        this.saleOrderSvc.createLabels([order.id])
            .subscribe({
                next: (res) => {
                    console.log(res);
                    res.data.forEach((label) => {
                        this.updateParcel(label.saleOrderId, label.parcelId, {
                            labelStatus: label.labelStatus });
                    });
                },
                error: (error) => {
                    this.notify.showError('Label can`t be created due to some error');
                },
            });
    }

    private updateParcel(orderId: number, parcelId: string | number | null, update: Partial<IParcelItem>): void {
        const order = this.dataSource.find((o) => o.id === orderId);
        if (!order?.parcel?.length) {
            return;
        }
        if (parcelId === null) {
            order.parcel.forEach((p) => Object.assign(p, update));
            return;
        }
        const parcel = order.parcel.find((p) => String(p.id) === String(parcelId));
        if (parcel) {
            Object.assign(parcel, update);
        }
    }

    public refreshParcelLabel(order: ISaleOrder): void {
        this.saleOrderSvc.refreshLabels([order.id])
            .subscribe({
                next: (res) => {
                    console.log(res);
                    res.data.forEach((label) => {
                        this.updateParcel(label.saleOrderId, label.parcelId, {
                            labelStatus: label.labelStatus });
                    });
                },
                error: (error) => {
                    this.notify.showError('Label can`t be updated due to some error');
                },
            });
    }
}
